import { FC } from 'react';
import { AmlChecker, RequestHistory } from '@/components';
import styles from './Dashboard.module.sass';

interface DashboardProps {}

const Dashboard: FC<DashboardProps> = () => {
  return (
    <div className={styles.dashboard}>
      <AmlChecker />
      <RequestHistory />
    </div>
  );
};

export default Dashboard;
